import React, { createContext, useContext, useCallback, useState, ReactNode } from 'react';

interface DropDownProviderProps {
  align?: 'left' | 'right';
}

interface DropDownContextData {
  openMenu(align: DropDownProviderProps): void;
  isShowLeft: boolean;
}

const DropDownContext = createContext<DropDownContextData>(
  {} as DropDownContextData,
);

interface DropDownProviderProps {
  children: ReactNode;
}

const DropDownProvider: React.FC<DropDownProviderProps> = ({ children }: DropDownProviderProps) => {
  const [isShowLeftT, setisShowLeftT] = useState(false);

  const openMenu = useCallback(
    ({ align }: DropDownProviderProps) => {
      //konsole.log(align, isShowLeftT);

      if (align === 'left') setisShowLeftT(!isShowLeftT);
      //konsole.log(align, isShowLeftT);
    },
    [isShowLeftT],
  );

  return (
    <DropDownContext.Provider
      value={{ openMenu, isShowLeft: isShowLeftT }}
    >
      {children}
    </DropDownContext.Provider>
  );
};

function useDropDown(): DropDownContextData {
  const context = useContext(DropDownContext);

  if (!context) {
    throw new Error('useDropDown must be used within a useDropDown');
  }

  return context;
}

export { DropDownProvider, useDropDown };
